module.exports = __webpack_public_path__ + "static/media/white-glow-circle.0d8ed529.png";